import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import { storage } from "firebase";

import { createFirestoreInstance } from "redux-firestore";
// import { composeWithDevTools } from "redux-devtools-extension";
import rootReducer from "./rootReducers";
import fbConfig from "../config/database/firebase";
import { persistReducer, persistStore } from "redux-persist";
import storageEngine from "redux-persist/lib/storage";

const persistConfig = {
  key: "root",
  storage: storageEngine
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// const reduxDevTool =
//   process.env.NODE_ENV === "development"
//     ? composeWithDevTools(applyMiddleware(thunk.withExtraArgument({ storage })))
//     : compose(applyMiddleware(thunk.withExtraArgument({ storage })));

const reduxDevTool = compose(
  applyMiddleware(thunk.withExtraArgument({ storage }))
);

// persist the store
const store = createStore(persistedReducer, reduxDevTool);

const persistor = persistStore(store);

export const rrfProps = {
  // firebase,
  config:
    (fbConfig,
    {
      useFirestoreForProfile: true,
      userProfile: "users",
      attachAuthIsReady: true
    }),
  dispatch: store.dispatch,
  createFirestoreInstance
};

export { store, persistor };
